import Model from '@/store/model';
import Payment from '@/store/models/user/payment';
import Promotion from '@/store/models/user/promotion';

class State extends Model {
  map(json) {
    super.map(json);

    if (json.payment !== undefined && json.payment !== null) {
      this.payment = new Payment();
      this.payment.map(json.payment);
    }

    if (json.promotion !== undefined && json.promotion !== null) {
      this.promotion = new Promotion();
      this.promotion.map(json.promotion);
    }
  }
}
export default State;
